import styled from 'styled-components'
import { defs } from './defs'

type SvgProps = {
  size?: number
  w?: number
  h?: number
}

const Svg = styled.svg<SvgProps>`
  display: inline-block;
  vertical-align: middle;
  width: ${({ w, size }) => (w || size ? `${w || size}em` : 'auto')};
  height: ${({ h, size }) => (h || size ? `${h || size}em` : 'auto')};
`

type SvgImgProps = {
  use: string
  w?: number
  h?: number
  size?: number
}

export const SvgImg = (props: SvgImgProps) => {
  if (!defs[props.use]) {
    return null
  }

  const { viewBox, markup } = defs[props.use]

  return (
    <Svg viewBox={viewBox} {...props}>
      {markup}
    </Svg>
  )
}
